// extracted by mini-css-extract-plugin
export default {"name":"kqdt6T","header":"BJs3di","opened":"TN1rpd"};